import get from 'lodash/get'

import {
  fetchCollection
} from './index'

import { areaTypeSchema } from '../schemas'

export const LOCATION_AREA_TYPES_REQUEST = 'LOCATION_AREA_TYPES_REQUEST'
export const LOCATION_AREA_TYPES_SUCCESS = 'LOCATION_AREA_TYPES_SUCCESS'
export const LOCATION_AREA_TYPES_FAILURE = 'LOCATION_AREA_TYPES_FAILURE'

function fetchAreaTypesByLocation (url, locationId, reload) {
  return fetchCollection({
    url,
    key: 'areaTypes',
    schema: areaTypeSchema,
    actions: [ LOCATION_AREA_TYPES_REQUEST, LOCATION_AREA_TYPES_SUCCESS, LOCATION_AREA_TYPES_FAILURE ],
    responseInterceptor: response => ({ ...response, locationId, reload })
  })
}

export function loadAreaTypesByLocation (locationId, nextPage) {
  return (dispatch, getState) => {
    let {
      nextPageUrl
    } = get(getState(), `pagination.areaTypesByLocation.${locationId}`, {})

    if (!nextPage) {
      nextPageUrl = `/locations/${locationId}/area_types`
    }

    return dispatch(fetchAreaTypesByLocation(nextPageUrl, locationId, !nextPage))
  }
}



// WEBPACK FOOTER //
// ./src/actions/area-types.js